import { SELECT_DICTIONARY } from '../constants/dictionary.constant';

export const hideComponent = (reason) => (reason === SELECT_DICTIONARY.others ? '' : 'none');
